<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="750px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2" v-if="modalloading || atnaujintiLoading">
          <v-card-text class="mb-0 pb-0">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" v-if="!modalloading && !atnaujintiLoading">
          <v-card-title class="mt-0 pt-1 pb-2 mb-4">
            <v-tabs v-model="tab" v-if="!isAsmuo">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab key="JUR" :disabled="disableTabJUR">
                <h4>{{ $t('Juridinis asmuo') }}</h4>
              </v-tab>
              <v-tab key="FIZ" :disabled="disableTabFIZ">
                <h4>{{ $t('Fizinis asmuo') }}</h4>
              </v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text class="mb-0 pb-0">
            <template v-if="showAsmuoError">
              <v-row>
                <v-col cols="12">
                  <el-savitarna-alert dense outlined type="error">
                    <span v-html="errorAsmuoMessage"></span>
                  </el-savitarna-alert>
                </v-col>
              </v-row>
            </template>
            <v-tabs-items v-model="tab">
              <v-tab-item key="JUR">
                <v-row v-if="getTipas === 'JUR'">
                  <v-col cols="12">
                    <el-text-field
                      :required="isRequiredJuridinisKodas"
                      :label="$t('Juridinio asmens kodas')"
                      :tooltip="juridinisAsmensKodasTooltip"
                      :readonly="isAsmuo"
                      :counter="juridinisKodasLength"
                      v-mask="juridinisKodasMask"
                      v-model="modalAsmuo.asm_asmens_kodas_jur"
                      autofocus
                    />
                  </v-col>
                  <v-col cols="12">
                    <el-text-field
                      :required="isRequiredJuridinisPavadinimas"
                      :label="$t('Pavadinimas')"
                      :tooltip="juridinisPavadinimasTooltip"
                      :readonly="isAsmuo"
                      :counter="200"
                      v-model="modalAsmuo.asm_pavadinimas"
                    />
                  </v-col>
                  <v-col cols="12" v-if="isForeign && false">
                    <el-autocomplete
                      :required="isRequired"
                      :items="salisList"
                      itemvalue="value"
                      itemtext="text"
                      :label="$t('Užsienio valstybė')"
                      tooltip="NtrPaslaugos. Modalas asmuo. Neregistruotas. Užsienio valstybė JUR"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_vls_kodas"
                    />
                  </v-col>
                </v-row>
                <!-- </template> -->
              </v-tab-item>
              <v-tab-item key="FIZ">
                <v-row v-if="getTipas === 'FIZ'">
                  <v-col cols="12" v-if="showForeignKodoTipas">
                    <span class="bold-label"
                      >{{ $t('Kodo tipas') }}
                      <el-need v-if="!isAsmuo" /><el-tooltip
                        inline
                        tooltip="NtrPaslaugos. Modalas asmuo. Kodo tipas"
                      />
                    </span>
                    <el-radio-group
                      inline
                      class="mt-0 mb-2"
                      :required="isRequired"
                      :items="filteredForeignKodoTipas"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_kodo_tipas"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" v-if="showForeignGimimoData">
                    <el-date-picker
                      :required="isRequired"
                      label="Gimimo data"
                      tooltip="NtrPaslaugos. Modalas asmuo. Gimimo data"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_gimimo_data"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" v-if="showForeignGimimoData">
                    <el-autocomplete
                      :required="isRequired"
                      :items="salisList"
                      itemvalue="value"
                      itemtext="text"
                      label="Užsienio valstybė"
                      tooltip="NtrPaslaugos. Modalas asmuo. Užsienio valstybė FIZ"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_vls_kodas"
                    />
                  </v-col>
                  <v-col cols="12" v-if="showFizinisKodas">
                    <el-text-field
                      key="FIZ_kodas"
                      :required="isRequired"
                      :label="$t('Asmens kodas')"
                      tooltip="NtrPaslaugos. Modalas asmuo. Asmens kodas"
                      :readonly="isAsmuo"
                      v-mask="fizinisKodasMask"
                      v-model="modalAsmuo.asm_asmens_kodas_fiz"
                      :autofocus="!isAsmuo"
                    />
                  </v-col>
                  <v-col cols="12">
                    <el-text-field
                      :required="isRequiredFizinisVardas"
                      :label="$t('Vardas')"
                      key="FIZ_vardas"
                      :tooltip="fizinisVardasTooltip"
                      :readonly="isAsmuo"
                      :counter="60"
                      v-model="modalAsmuo.asm_fiz_vardas"
                      :autofocus="isForeign && !isAsmuo"
                    />
                  </v-col>
                  <v-col cols="12">
                    <el-text-field
                      :required="isRequiredFizinisPavarde"
                      :label="$t('Pavardė')"
                      key="FIZ_pavarde"
                      :tooltip="fizinisPavardeTooltip"
                      :readonly="isAsmuo"
                      :counter="60"
                      v-model="modalAsmuo.asm_fiz_pavarde"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
            <v-row v-if="showPareiskejas">
              <v-col cols="12" class="mb-2">
                <el-checkbox
                  class="mb-3"
                  label="Pareiškėjas"
                  tooltip="NtrPaslaugos. Modalas asmuo. Pareiškėjas"
                  v-model="modalAsmuo.sasm_pareiskejas"
                  :readonly="readonlyPareiskejas"
                />
              </v-col>
            </v-row>
            <v-row class="pb-2" v-if="showRoleList">
              <v-col cols="12" class="mb-2">
                <span class="label text-inline"
                  >{{ $t('Sutarties šalis')
                  }}<el-need :need="isNeed" v-if="!readonly && changeRole"
                /></span>
                <el-radio-group
                  inline
                  required
                  :label="$t('Sutarties šalis')"
                  :items="roleList"
                  :readonly="readonly || tikAdresas || !changeRole"
                  v-model="modalAsmuo.sasm_role_objekte"
                />
              </v-col>
            </v-row>
            <template v-if="showAsmenysList">
              <template v-if="showAsmuoWarning">
                <v-row>
                  <v-col cols="12">
                    <v-alert dense outlined type="warning" class="ispejimas">
                      <span v-html="warningAsmuoMessage"></span>
                    </v-alert>
                  </v-col>
                </v-row>
              </template>

              <el-asmenys-list
                :asmenys="asmenysList"
                :tipas="getTipas"
                @selectAsmuo="selectAsmuo"
              />
            </template>
          </v-card-text>
          <v-card-actions v-if="!isAsmuo">
            <el-switch
              v-if="showForeignSwitch"
              :label="asmuoNeregistruotasTitle"
              :tooltip="asmuoNeregistruotasTooltip"
              :readonly="isAsmuo || forceForeign"
              v-model="modalAsmuo.foreign"
            />
            <v-spacer></v-spacer>
            <el-button
              primary
              @click.native="checkRegistras()"
              :loading="loadingRegistras"
              :disabled="disabledIeskoti"
            >
              {{ $t('Tikrinti registre') }}
            </el-button>
          </v-card-actions>
        </v-card>
        <el-asmuo-pastas
          :key="asmuoPastasKey"
          :validate-key="asmuoPastasKey"
          v-model="sasm_el_pastas"
          v-if="isSavitarna && isAsmuo && !isMires && !atstovas"
          :readonly="readonly"
          autofocus
          ntrpaslaugos
          :need="false"
        />

        <v-card class="mb-3" v-if="showDokumentaiList">
          <v-card-text class="mb-0 pb-0">
            <v-tabs v-model="dokumentaiTab" class="mb-3">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab class="dokumentai-tab" v-if="this.showAdresas">
                <h4>Adresas</h4>
              </v-tab>
              <v-tab class="dokumentai-tab" v-if="this.showVeikiantisPagal">
                <h4>Veikiantis pagal</h4>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="dokumentaiTab">
              <v-tab-item v-if="this.showAdresas">
                <el-asmuo-adresas
                  :readonly="readonly"
                  :foreign="isForeign"
                  :fizinis="isFizinis"
                  v-model="modalAsmuo.adresas"
                  v-if="isAsmuo && !isMires"
                  autofocus
                  ntrpaslaugos
                />
              </v-tab-item>

              <v-tab-item v-if="this.showVeikiantisPagal">
                <el-veikiantis-pagal
                  :key="veikiantisPagalKey"
                  :readonly="readonly"
                  :foreign="isForeign"
                  ntrpaslaugos
                  :asm-kodas="modalAsmuo.asm_asmens_kodas"
                  v-model="modalAsmuo.sasm_veikiantis_pagal"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>

        <el-asmuo-adresas
          :readonly="readonly"
          :foreign="isForeign"
          :fizinis="isFizinis"
          v-model="modalAsmuo.adresas"
          v-if="isAsmuo && !isMires && !atstovas"
          autofocus
          ntrpaslaugos
        />
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <el-button
          v-if="showAtnaujinti"
          @click.native.stop="atnaujintiAsmuo()"
          :loading="atnaujintiLoading"
        >
          {{ $t('Atnaujinti') }}
        </el-button>
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()">
          {{ $t('Atšaukti') }}
        </el-button>
        <el-button
          primary
          :loading="saveLoading"
          @click.native="saveData()"
          v-if="isAsmuo && !readonly"
        >
          {{ $t('Saugoti') }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busenaNtrTipas from '@/mixins/busenaNtrTipas'
import NtrPaslaugosMap from '../ntrpaslaugos/NtrPaslaugosMap'
import TeikejasRengiamiSearch from '../zurnalas/TeikejasRengiamiSearch.vue'

export default {
  name: 'ModalPrasymasAsmuo',
  mixins: [userRole, busenaNtrTipas],
  props: {
    asmuoRole: String,
    changeRole: Boolean,
    title: String,
    value: Boolean,
    asmuo: Object,
    salys: Array,
    forceForeign: Boolean,
    atstovavimoPagrindas: Array,
    readonly: Boolean,
    parentAtstovasId: Number,
    perleidimas: Boolean,
    atnaujinti: Boolean,
    tikAdresas: Boolean,
    saveFail: Boolean,
  },
  data() {
    return {
      loading: true,
      loadingRegistras: false,
      modalAsmuo: {
        asm_asmens_kodas_jur: null,
        asm_pavadinimas: null,
        asm_asmens_kodas_fiz: null,
        asm_asmens_kodas: null,
        asm_fiz_vardas: null,
        asm_fiz_pavarde: null,
        asm_gimimo_data: null,
        asm_vls_kodas: null,
      },
      sasm_el_pastas: null,
      asmenysList: [],
      showAsmenysList: false,
      showAsmuoError: false,
      errorAsmuoMessage: null,
      showAsmuoWarning: false,
      warningAsmuoMessage: null,
      showAsmuoSave: false,
      modalloading: true,
      atnaujintiLoading: false,
      tab: 0,
      saveLoading: false,
      dokumentaiTab: 0,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters([
      'prasymasID',
      'prasymasTipas',
      'appSavitarna',
      'pagrindasKodas',
    ]),
    showTitle() {
      if (this.title) {
        return this.title
      } else {
        if (this.isAsmuo) {
          if (this.isFizinis) {
            return this.$t('Fizinis asmuo')
          } else {
            return this.$t('Juridinis asmuo')
          }
        } else {
          return this.$t('Naujas asmuo')
        }
      }
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    showForeignSwitch() {
      return this.isTipasJUR || this.isTipasFIZ
    },
    compAsmuoRole() {
      if (this.isNuoma) {
        return this.modalAsmuo.sasm_role_objekte ?? this.asmuoRole
      } else {
        return this.asmuoRole
      }
    },
    asmuoPastasKey() {
      return 'pastas' + this.modalAsmuo.sasm_id
    },
    isAsmuo() {
      return this.modalAsmuo && this.modalAsmuo.amn_id > 0
    },
    isForeign() {
      return (this.modalAsmuo && this.modalAsmuo.foreign) ?? false
    },
    isFizinis() {
      return (this.modalAsmuo && this.modalAsmuo.tipas === 'FIZ') ?? false
    },
    disabledIeskoti() {
      return false
    },
    getTipas() {
      return this.tab === 0 ? 'JUR' : 'FIZ'
    },
    isTipasFIZ() {
      return this.getTipas === 'FIZ'
    },
    isTipasJUR() {
      return this.getTipas === 'JUR'
    },
    salisList() {
      return this.salys
    },
    savininkas() {
      return (
        this.compAsmuoRole === NtrPaslaugosMap.getAsmuoRole('savininkas').key
      )
    },
    nuomotojas() {
      return (
        this.compAsmuoRole === NtrPaslaugosMap.getAsmuoRole('nuomotojas').key
      )
    },
    nuomininkas() {
      return (
        this.compAsmuoRole === NtrPaslaugosMap.getAsmuoRole('nuomininkas').key
      )
    },
    panaudaDavejas() {
      return (
        this.compAsmuoRole ===
        NtrPaslaugosMap.getAsmuoRole('panauda_davejas').key
      )
    },
    panaudaGavejas() {
      return (
        this.compAsmuoRole ===
        NtrPaslaugosMap.getAsmuoRole('panauda_gavejas').key
      )
    },
    atstovas() {
      return this.compAsmuoRole === NtrPaslaugosMap.getAsmuoRole('atstovas').key
    },
    isNuoma() {
      return this.isPrasymasNuoma
    },
    isPanauda() {
      return this.isPrasymasPanauda
    },
    isSubnuoma() {
      return this.isPrasymasSubnuoma
    },
    isPreliminari() {
      return this.isPrasymasPreliminari
    },
    isPirmenybe() {
      return this.isPrasymasPirmenybe
    },
    roleList() {
      if (this.isPanauda) {
        return this.panaudaRoleList
      }
      if (this.isSubnuoma) {
        return this.subnuomaRoleList
      }
      if (this.isPreliminari) {
        return this.preliminariRoleList
      }
      return this.nuomaRoleList
    },
    nuomaRoleList() {
      return [
        {
          label: NtrPaslaugosMap.getAsmuoRole('nuomotojas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Nuomotojas`,
          value: NtrPaslaugosMap.getAsmuoRole('nuomotojas').key,
        },
        {
          label: NtrPaslaugosMap.getAsmuoRole('nuomininkas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Nuomininkas`,
          value: NtrPaslaugosMap.getAsmuoRole('nuomininkas').key,
        },
      ]
    },
    panaudaRoleList() {
      return [
        {
          label: NtrPaslaugosMap.getAsmuoRole('panauda_davejas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Panauda davėjas`,
          value: NtrPaslaugosMap.getAsmuoRole('panauda_davejas').key,
        },
        {
          label: NtrPaslaugosMap.getAsmuoRole('panauda_gavejas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Panauda gavėjas`,
          value: NtrPaslaugosMap.getAsmuoRole('panauda_gavejas').key,
        },
      ]
    },
    subnuomaRoleList() {
      return [
        {
          label: NtrPaslaugosMap.getAsmuoRole('subnuomotojas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Subnuomotojas`,
          value: NtrPaslaugosMap.getAsmuoRole('subnuomotojas').key,
        },
        {
          label: NtrPaslaugosMap.getAsmuoRole('subnuomininkas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Subnuomininkas`,
          value: NtrPaslaugosMap.getAsmuoRole('subnuomininkas').key,
        },
      ]
    },
    preliminariRoleList() {
      return [
        {
          label: NtrPaslaugosMap.getAsmuoRole('pirkejas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Pirkėjas`,
          value: NtrPaslaugosMap.getAsmuoRole('pirkejas').key,
        },
        {
          label: NtrPaslaugosMap.getAsmuoRole('pardavejas').title,
          tooltip: `NtrPaslaugos. Modalas asmuo. Sutarties šalis. Pardavėjas`,
          value: NtrPaslaugosMap.getAsmuoRole('pardavejas').key,
        },
      ]
    },
    showRoleList() {
      return (
        this.isAsmuo &&
        !this.atstovas &&
        (this.isNuoma ||
          this.isPanauda ||
          this.isSubnuoma ||
          this.isPreliminari)
      )
    },
    isNeed() {
      return !this.isAsmuo
    },
    isRequired() {
      return !this.isAsmuo
    },
    isRequiredJuridinisKodas() {
      return this.isRequired && !this.modalAsmuo.asm_pavadinimas
    },
    juridinisKodasLength() {
      return this.isForeign ? 20 : 9
    },
    juridinisKodasMask() {
      const mask = 'N'
      return mask.repeat(this.juridinisKodasLength)
    },
    fizinisKodasMask() {
      let mask = '#'
      let fizinisKodasLength = 11

      if (this.modalAsmuo.asm_kodo_tipas === 'eidas') {
        mask = 'X'
        fizinisKodasLength = 50
      }
      return mask.repeat(fizinisKodasLength)
    },
    isRequiredJuridinisPavadinimas() {
      return this.isRequired && !this.modalAsmuo.asm_asmens_kodas_jur
    },
    isRequiredFizinisVardas() {
      return (
        this.isRequired &&
        (this.isForeign ||
          !this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ]))
      )
    },
    isRequiredFizinisPavarde() {
      return (
        this.isRequired &&
        (this.isForeign ||
          !this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ]))
      )
    },
    juridinisAsmensKodasTooltip() {
      return this.isForeign
        ? 'NtrPaslaugos. Modalas asmuo. Neregistruotas. Juridinio asmens kodas'
        : 'NtrPaslaugos. Modalas asmuo. Juridinio asmens kodas'
    },
    juridinisPavadinimasTooltip() {
      return this.isForeign
        ? 'NtrPaslaugos. Modalas asmuo. Neregistruotas. Pavadinimas'
        : 'NtrPaslaugos. Modalas asmuo. Pavadinimas'
    },
    fizinisVardasTooltip() {
      return this.isForeign
        ? 'NtrPaslaugos. Modalas asmuo. Neregistruotas. Vardas'
        : 'NtrPaslaugos. Modalas asmuo. Vardas'
    },
    fizinisPavardeTooltip() {
      return this.isForeign
        ? 'NtrPaslaugos. Modalas asmuo. Neregistruotas. Pavardė'
        : 'NtrPaslaugos. Modalas asmuo. Pavardė'
    },
    asmuoNeregistruotasTitle() {
      return this.getTipas === 'JUR'
        ? 'Asmuo neregistruotas Juridinių asmenų registre'
        : 'Asmuo neregistruotas LR gyventojų registre'
    },
    asmuoNeregistruotasTooltip() {
      return this.getTipas === 'JUR'
        ? 'NtrPaslaugos. Modalas asmuo. Asmuo neregistruotas JUR'
        : 'NtrPaslaugos. Modalas asmuo. Asmuo neregistruotas FIZ'
    },
    compForeign() {
      return this.modalAsmuo.foreign
    },
    isSavitarna() {
      return this.appSavitarna
    },
    disableTabJUR() {
      return this.atstovas || this.isPrasymasSeima || this.isPrasymasBendra
    },
    disableTabFIZ() {
      return this.role('EL_JA') && !this.role('EL_FA')
    },
    errorMessageForeignJUR() {
      return (
        this.$t(
          'Juridinis asmuo užsienietis pagal įvestus kriterijus nerastas.'
        ) +
        '<br>' +
        this.$t(
          'Norėdami, kad juridinis asmuo būtų įregistruotas RC, kreipkitės el. paštu info@registrucentras.lt laiško antraštėje nurodydami - JA asmens užsieniečio įvedimas.'
        ) +
        '<br>' +
        this.$t(
          'Laiško tekste privalomus parametrus: pavadinimą, užsienio valstybę. Papildomus neprivalomus parametrus: asmens kodą (jei turi), adresą, registracijos datą.'
        )
      )
    },
    showAtnaujinti() {
      return (
        this.atnaujinti &&
        this.isAsmuo &&
        this.asmuo.sasm_id > 0 &&
        !this.readonly
      )
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isMires() {
      return this.modalAsmuo.yra_mires
    },
    foreignKodoTipas() {
      return [
        {
          label: this.$t('ILTU'),
          value: 'iltu',
        },
        {
          label: this.$t('eIDAS'),
          value: 'eidas',
          hide: !this.showEidasKodas,
        },
        {
          label: this.$t('Gimimo data'),
          value: 'data',
          hide: !this.showDataKodas,
        },
      ]
    },
    filteredForeignKodoTipas() {
      return this.foreignKodoTipas.filter(item => {
        return !item.hide
      })
    },
    showPareiskejas() {
      return (
        !this.isSavitarna &&
        this.isAsmuo &&
        this.isPrasymasSeima &&
        !(this.isPrasymasIsregistravimas && this.isMires)
      )
    },
    readonlyPareiskejas() {
      return (
        this.isPrasymasSeima &&
        (this.isPrasymasIregistravimas ||
          this.isPrasymasPerkelimas ||
          (this.isPrasymasIsregistravimas &&
            !this.isPagrindasNutrukusiSantuoka))
      )
    },
    isPagrindasNutrukusiSantuoka() {
      return this.pagrindasKodas === 'nutrukus_santuokai'
    },
    showEidasKodas() {
      return (
        this.isForeign &&
        this.isAsmuo &&
        this.modalAsmuo.asm_kodo_tipas === 'eidas'
      )
    },
    showDataKodas() {
      return (
        this.isForeign &&
        this.isAsmuo &&
        this.modalAsmuo.asm_kodo_tipas === 'data'
      )
    },
    showForeignKodoTipas() {
      return this.isForeign
    },
    showForeignGimimoData() {
      return this.isForeign && this.modalAsmuo.asm_kodo_tipas === 'data'
    },
    showFizinisKodas() {
      if (!this.isForeign) {
        return true
      }
      return this.isForeign && this.modalAsmuo.asm_kodo_tipas !== 'data'
    },
    showDokumentaiList() {
      return (
        this.isAsmuo &&
        this.atstovas &&
        this.isPirmenybe &&
        (this.showAdresas || this.showVeikiantisPagal)
      )
    },
    showAdresas() {
      return this.isAsmuo && !this.isMires && !this.atstovas
    },
    showVeikiantisPagal() {
      return this.isPirmenybe && this.isFizinis && this.atstovas
    },
    veikiantisPagalKey() {
      return 'veikiantisPagal' + this.modalAsmuo.sasm_id
    },
  },
  created() {
    if (this.asmuo.sasm_id > 0) {
      this.modalAsmuo = {}
      this.getAsmuoById(this.asmuo.sasm_id)
    } else {
      this.getAsmuo()
    }
  },
  watch: {
    tab(val) {
      if (!this.isAsmuo) {
        this.modalAsmuo.asm_asmens_kodas_jur = null
        if (!this.isLocal) {
          // this.modalAsmuo.asm_asmens_kodas_fiz = null
        }
      }
      this.showAsmenysList = false
      if (val === 1 && !this.showForeignSwitch) {
        this.modalAsmuo.foreign = false
      }
      this.resetError()
    },
    compForeign() {
      this.showAsmenysList = false
      this.resetError()
    },
    saveFail(val) {
      if (val) {
        this.saveLoading = false
      }
    },
    filteredForeignKodoTipas(val) {
      if (!this.isAsmuo & this.isForeign && val.length === 1) {
        this.modalAsmuo.asm_kodo_tipas = val[0].value
      }
    },
  },
  methods: {
    resetError() {
      this.errorAsmuoMessage = null
      this.showAsmuoError = false
      this.warningAsmuoMessage = null
      this.showAsmuoWarning = false
      this.showAsmuoSave = false
      this.$validator.reset()
      // this.$nextTick(() => this.$validator.reset())
    },
    getAsmuo() {
      this.modalAsmuo = this.asmuo
      this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
      this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
      this.sasm_el_pastas = this.asmuo.sasm_el_pastai
        ? this.asmuo.sasm_el_pastai.join(',')
        : null
      this.tab = this.isFizinis || this.disableTabJUR ? 1 : 0
      this.modalloading = false

      if (this.atstovas) {
        this.tab = 1
      }
    },
    getAsmuoById(sasm_id) {
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/${sasm_id}`)
        .then(res => {
          this.modalAsmuo = res.data.asmuo
          this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
          this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas

          if (this.modalAsmuo.foreign && !this.modalAsmuo.asm_kodo_tipas) {
            this.modalAsmuo.asm_kodo_tipas = this.modalAsmuo.asm_asmens_kodas
              ? 'eidas'
              : 'data'
          }
          this.sasm_el_pastas = this.modalAsmuo.sasm_el_pastai
            ? this.modalAsmuo.sasm_el_pastai.join(',')
            : null
          this.tab = this.isFizinis ? 1 : 0
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.modalloading = false
        })
    },
    atnaujintiAsmuo() {
      this.atnaujintiLoading = true
      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/${this.asmuo.sasm_id}/atnaujinimas`
        )
        .then(res => {
          this.modalAsmuo = res.data.asmuo
          this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
          this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
          this.sasm_el_pastas = res.data.asmuo.sasm_el_pastai
            ? res.data.asmuo.sasm_el_pastai.join(',')
            : null
          this.tab = this.isFizinis ? 1 : 0
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.atnaujintiLoading = false
        })
    },
    checkRegistras() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loadingRegistras = true
          this.showAsmuoError = false
          this.errorAsmuoMessage = null
          this.warningAsmuoMessage = null
          this.showAsmuoWarning = false
          this.showAsmuoSave = false

          // const data = {
          //   asm_asmens_kodas:
          //     this.getTipas === 'FIZ'
          //       ? this.modalAsmuo.asm_asmens_kodas_fiz
          //       : this.modalAsmuo.asm_asmens_kodas_jur,
          //   asm_pavadinimas: this.modalAsmuo.asm_pavadinimas,
          //   asm_gimimo_data: this.modalAsmuo.asm_gimimo_data,
          //   tipas: this.getTipas,
          //   asm_fiz_vardas: this.modalAsmuo.asm_fiz_vardas,
          //   asm_fiz_pavarde: this.modalAsmuo.asm_fiz_pavarde,
          //   foreign: this.isForeign,
          //   asm_kodo_tipas: this.modalAsmuo.asm_kodo_tipas,
          // }
          let data = {
            asm_asmens_kodas: null,
            asm_pavadinimas: null,
            asm_gimimo_data: null,
            asm_vls_kodas: null,
            tipas: null,
            asm_fiz_vardas: null,
            asm_fiz_pavarde: null,
            foreign: null,
            asm_kodo_tipas: null,
          }

          data.tipas = this.getTipas
          data.foreign = this.isForeign
          if (this.isTipasFIZ) {
            data.asm_fiz_vardas = this.modalAsmuo.asm_fiz_vardas
            data.asm_fiz_pavarde = this.modalAsmuo.asm_fiz_pavarde
            data.asm_asmens_kodas = this.modalAsmuo.asm_asmens_kodas_fiz

            if (this.isForeign) {
              data.asm_kodo_tipas = this.modalAsmuo.asm_kodo_tipas
              if (this.showForeignGimimoData) {
                data.asm_gimimo_data = this.modalAsmuo.asm_gimimo_data
                data.asm_vls_kodas = this.modalAsmuo.asm_vls_kodas
                data.asm_asmens_kodas = null
              }
            }
          }
          if (this.isTipasJUR) {
            data.asm_asmens_kodas = this.modalAsmuo.asm_asmens_kodas_jur
            data.asm_pavadinimas = this.modalAsmuo.asm_pavadinimas
          }

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/search`, data)
            .then(res => {
              if (res.data.asmenys.length === 1 && !res.data.forceList) {
                this.selectAsmuo(res.data.asmenys[0])
              } else {
                this.asmenysList = res.data.asmenys
                this.showAsmenysList = true
              }
              this.resetError()

              if (res.data.warning) {
                this.warningAsmuoMessage = res.data.warning
                this.showAsmuoWarning = true
              }
            })
            .catch(err => {
              if (err.response.status === 404) {
                this.errorAsmuoMessage = err.response.data.message
                this.showAsmuoError = true
                if (this.getTipas === 'FIZ' && this.isForeign) {
                  this.showAsmuoSave = true
                }
                if (this.getTipas === 'JUR' && this.isForeign) {
                  this.errorAsmuoMessage = this.errorMessageForeignJUR
                }
              } else {
                window._VMA.$emit('DATA_ERROR', err.response.data.message)
              }
            })
            .finally(() => {
              this.loadingRegistras = false
              this.modalloading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    saveRegistras() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loadingRegistras = true
          this.showAsmuoError = false
          this.errorAsmuoMessage = null
          this.warningAsmuoMessage = null
          this.showAsmuoWarning = false

          const data = {
            asm_fiz_vardas: this.modalAsmuo.asm_fiz_vardas,
            asm_fiz_pavarde: this.modalAsmuo.asm_fiz_pavarde,
            asm_gimimo_data: this.modalAsmuo.asm_gimimo_data,
            asm_vls_kodas: this.modalAsmuo.asm_vls_kodas,
          }

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/kelti`, data)
            .then(res => {
              if (res.data.asmenys.length === 1) {
                this.selectAsmuo(res.data.asmenys[0])
              } else {
                this.asmenysList = res.data.asmenys
                this.showAsmenysList = true
              }
              this.resetError()
            })
            .catch(err => {
              if (err.response.status === 404) {
                this.errorAsmuoMessage = err.response.data.message
                this.showAsmuoError = true
              } else {
                window._VMA.$emit('DATA_ERROR', err.response.data.message)
              }
            })
            .finally(() => {
              this.loadingRegistras = false
              this.modalloading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    selectAsmuo(asmuo) {
      this.modalAsmuo = asmuo
      this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
      this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
      this.modalAsmuo.sasm_atpirkimo_pageidavimas = false
      this.modalAsmuo.parent_atstovas_id = this.parentAtstovasId
      this.sasm_el_pastas = this.modalAsmuo.sasm_el_pastai
        ? this.modalAsmuo.sasm_el_pastai.join(',')
        : null
      this.tab = this.isFizinis ? 1 : 0
    },
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.saveLoading = true
          this.modalAsmuo.sasm_el_pastas = this.sasm_el_pastas
          if (this.atstovas) {
            this.$emit('savedAtstovas', this.modalAsmuo)
          } else {
            this.$emit('savedData', this.modalAsmuo)
          }
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
      if (!this.isAsmuo) {
        this.modalAsmuo = {}
        this.showAsmuoError = false
        this.showAsmuoWarning = false
      }
    },
    submit() {
      if (!this.readonly) {
        if (this.isAsmuo) {
          this.saveData()
        } else {
          this.checkRegistras()
        }
      }
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.label {
  font-size: 13px;
  font-weight: 600;
}
.ispejimas {
  color: #e4800d !important;
}
</style>
